import script from "./CarouselItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselItem.vue?vue&type=script&setup=true&lang=js"

import "./CarouselItem.vue?vue&type=style&index=0&id=537407e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-537407e5"]])

export default __exports__